webpackJsonp([1],Array(21).concat([
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_TEMP_LOGOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_LOGOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CURRENT_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PREVIOUS_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INCREASE_ANSWER_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_ANSWER_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return START_GAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FINISH_GAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_HIGH_SCORES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_FIREBASE_FEEDBACK; });
var SET_USER = 'SET_USER';
var SET_TEMP_LOGOS = 'SET_TEMP_LOGOS';
var SET_AMOUNT = 'SET_AMOUNT';
var SET_LOGOS = 'SET_LOGOS';
var SET_CURRENT_LOGO = 'SET_CURRENT_LOGO';
var SET_PREVIOUS_LOGO = 'SET_PREVIOUS_LOGO';
var SET_OPTIONS = 'SET_OPTIONS';
var INCREASE_ANSWER_COUNT = 'INCREASE_ANSWER_COUNT';
var SET_ANSWER_COUNT = 'SET_ANSWER_COUNT';
var START_GAME = 'START_GAME';
var FINISH_GAME = 'FINISH_GAME';
var TOGGLE_SOUND = 'TOGGLE_SOUND';
var SET_HIGH_SCORES = 'SET_HIGH_SCORES';
var SET_FIREBASE_FEEDBACK = 'SET_FIREBASE_FEEDBACK';

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(144),
  /* scopeId */
  "data-v-5dc09f95",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_user__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_sound__ = __webpack_require__(61);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_4__modules_user__["a" /* default */],
    sound: __WEBPACK_IMPORTED_MODULE_5__modules_sound__["a" /* default */]
  },
  strict: false
}));

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(143),
  /* scopeId */
  "data-v-50fb2485",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getJSON: function getJSON(url, callback) {
    var xhr = new window.XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.responseType = 'json';
    xhr.onload = function () {
      if (xhr.status === 200) {
        callback(null, xhr.response);
      } else {
        callback(xhr.status);
      }
    };
    xhr.send();
  },
  shuffle: function shuffle(array) {
    var j = void 0,
        x = void 0,
        i = void 0;
    for (i = array.length; i; i--) {
      j = Math.floor(Math.random() * i);
      x = array[i - 1];
      array[i - 1] = array[j];
      array[j] = x;
    }
    return array;
  },
  generateIDs: function generateIDs(array) {
    array.forEach(function (val, index) {
      array[index].id = index;
    });
    return array;
  },
  getAnswerOptions: function getAnswerOptions(logos, amount, currentId, previousId) {
    var optionNumbers = [];
    optionNumbers.push(currentId);

    while (optionNumbers.length < 4) {
      var randomNumber = Math.floor(Math.random() * amount);
      if (!optionNumbers.includes(randomNumber) && (!previousId || previousId !== randomNumber)) {
        optionNumbers.push(randomNumber);
      }
    }

    optionNumbers = this.shuffle(optionNumbers);

    return [logos[optionNumbers[0]], logos[optionNumbers[1]], logos[optionNumbers[2]], logos[optionNumbers[3]]];
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Game__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ranking__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ranking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Ranking__);













__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_5__App___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Game___default.a
  }, {
    path: 'ranking',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Ranking___default.a
  }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], router);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}).$mount('#app');

document.querySelector('.loading-container').style.display = 'none';

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routePath", function() { return routePath; });
var route = function route(state) {
  return state.route;
};
var routePath = function routePath(state) {
  return state.route.path;
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_app__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(21);



var _mutations;




var state = {
  logos: [],
  tempLogos: [],
  answerCount: 0,
  amount: 0,
  currentLogo: {},
  previousLogo: {},
  options: [],
  gameFinished: false,
  startTime: new Date().getTime(),
  endTime: 0,
  highScores: [],
  firebaseFeedback: false
};

var getters = {
  logos: function logos(state) {
    return state.logos;
  },
  answerCount: function answerCount(state) {
    return state.answerCount;
  },
  currentLogo: function currentLogo(state) {
    return state.currentLogo;
  },
  previousLogo: function previousLogo(state) {
    return state.previousLogo;
  },
  options: function options(state) {
    return state.options;
  },
  gameFinished: function gameFinished(state) {
    return state.gameFinished;
  },
  amount: function amount(state) {
    return state.amount;
  },
  startTime: function startTime(state) {
    return state.startTime;
  },
  endTime: function endTime(state) {
    return state.endTime;
  },
  highScores: function highScores(state) {
    return state.highScores;
  },
  firebaseFeedback: function firebaseFeedback(state) {
    return state.firebaseFeedback;
  }
};

var actions = {
  initializeLogos: function initializeLogos(_ref, callback) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* default */].getJSON('static/logos.json', function (error, tempLogos) {
      if (typeof tempLogos === 'string') {
        tempLogos = JSON.parse(tempLogos);
      }

      if (error) {
        tempLogos = JSON.parse(window.localStorage.getItem('logos'));
      } else {
        window.localStorage.setItem('logos', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tempLogos));
      }

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_TEMP_LOGOS */], { tempLogos: tempLogos });

      callback();
    });
  },
  setCurrentLogo: function setCurrentLogo(_ref2, currentLogo) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var previousLogo = state.currentLogo;
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_PREVIOUS_LOGO */], { previousLogo: previousLogo });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_CURRENT_LOGO */], { currentLogo: currentLogo });
  },
  setOptions: function setOptions(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var options = __WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* default */].getAnswerOptions(state.logos, state.amount, state.currentLogo.id, state.previousLogo.id);
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_OPTIONS */], { options: options });
  },
  increaseAnswerCount: function increaseAnswerCount(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* INCREASE_ANSWER_COUNT */]);
  },
  finishGame: function finishGame(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* FINISH_GAME */]);
  },
  restartGame: function restartGame(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var logos = __WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* default */].generateIDs(__WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* default */].shuffle(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.tempLogos))));
    var count = 0;
    var amount = logos.length;
    var currentLogo = logos[count];
    var previousLogo = {};
    var options = __WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* default */].getAnswerOptions(logos, amount, currentLogo.id);

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_LOGOS */], { logos: logos });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_AMOUNT */], { amount: amount });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_ANSWER_COUNT */], { count: count });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_CURRENT_LOGO */], { currentLogo: currentLogo });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_PREVIOUS_LOGO */], { previousLogo: previousLogo });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_OPTIONS */], { options: options });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* START_GAME */]);
  },
  setHighScores: function setHighScores(_ref7, scores) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_HIGH_SCORES */], { scores: scores });
  },
  setFirebaseFeedback: function setFirebaseFeedback(_ref8) {
    var commit = _ref8.commit;

    var feedback = true;
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* SET_FIREBASE_FEEDBACK */], { feedback: feedback });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_TEMP_LOGOS */], function (state, _ref9) {
  var tempLogos = _ref9.tempLogos;

  state.tempLogos = tempLogos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_AMOUNT */], function (state, _ref10) {
  var amount = _ref10.amount;

  state.amount = amount;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_LOGOS */], function (state, _ref11) {
  var logos = _ref11.logos;

  state.logos = logos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_CURRENT_LOGO */], function (state, _ref12) {
  var currentLogo = _ref12.currentLogo;

  state.currentLogo = currentLogo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_PREVIOUS_LOGO */], function (state, _ref13) {
  var previousLogo = _ref13.previousLogo;

  state.previousLogo = previousLogo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_OPTIONS */], function (state, _ref14) {
  var options = _ref14.options;

  state.options = options;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* INCREASE_ANSWER_COUNT */], function (state) {
  state.answerCount++;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_ANSWER_COUNT */], function (state, _ref15) {
  var count = _ref15.count;

  state.answerCount = count;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* START_GAME */], function (state) {
  state.gameFinished = false;
  state.startTime = new Date().getTime();
  state.endTime = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* FINISH_GAME */], function (state) {
  state.gameFinished = true;
  state.endTime = new Date().getTime();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_HIGH_SCORES */], function (state, _ref16) {
  var scores = _ref16.scores;

  state.highScores = scores;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* SET_FIREBASE_FEEDBACK */], function (state, _ref17) {
  var feedback = _ref17.feedback;

  state.firebaseFeedback = feedback;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_howler__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(21);




var gameEnd = new __WEBPACK_IMPORTED_MODULE_1_howler__["Howl"]({
  src: ['../../static/sounds/finish.mp3', '../../static/sounds/finish.ogg'],
  volume: 0.5
});

var correct = new __WEBPACK_IMPORTED_MODULE_1_howler__["Howl"]({
  src: ['../../static/sounds/correct.mp3', '../../static/sounds/correct.ogg'],
  volume: 0.5
});

var wrong = new __WEBPACK_IMPORTED_MODULE_1_howler__["Howl"]({
  src: ['../../static/sounds/gameover.mp3', '../../static/sounds/gameover.ogg'],
  rate: 1.3,
  volume: 0.5
});

var state = {
  sound: window.localStorage.getItem('sound') ? JSON.parse(window.localStorage.getItem('sound')) : true
};

var getters = {
  sound: function sound(state) {
    return state.sound;
  }
};

var actions = {
  playSound: function playSound(_ref, type) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.sound) {
      switch (type) {
        case 'game-end':
          gameEnd.play();
          break;
        case 'correct':
          correct.play();
          break;
        case 'wrong':
          wrong.play();
          break;
      }
    }
  },
  toggleSound: function toggleSound(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* TOGGLE_SOUND */]);
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* TOGGLE_SOUND */], function (state) {
  state.sound = !state.sound;
  window.localStorage.setItem('sound', state.sound);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(21);



var state = {
  user: null
};

var getters = {
  user: function user(state) {
    return state.user;
  }
};

var actions = {
  setUser: function setUser(_ref, user) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_USER */], { user: user });
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_USER */], function (state, _ref2) {
  var user = _ref2.user;

  state.user = user;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProgressBar__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Credits__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Credits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SoundToggle__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SoundToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SoundToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LoginView__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LoginView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_LoginView__);













var firebaseConfig = {
  apiKey: 'AIzaSyDzKhNG-bafYPDTbAFFGqSscGJ7a-rdB9M',
  authDomain: 'javascript-game.firebaseapp.com',
  databaseURL: 'https://javascript-game.firebaseio.com',
  storageBucket: 'javascript-game.appspot.com',
  messagingSenderId: '853137885896'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_5__components_ProgressBar___default.a,
    Credits: __WEBPACK_IMPORTED_MODULE_6__components_Credits___default.a,
    SoundToggle: __WEBPACK_IMPORTED_MODULE_7__components_SoundToggle___default.a,
    LoginView: __WEBPACK_IMPORTED_MODULE_8__components_LoginView___default.a
  },
  created: function created() {
    this.firebase();

    if (this.routePath === '/ranking') {
      this.getHighScores();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['amount', 'answerCount', 'startTime', 'endTime', 'user', 'routePath', 'highScores'])),
  watch: {
    routePath: function routePath(path) {
      if (path === '/ranking' && this.highScores.length === 0) {
        this.getHighScores();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['setUser', 'setHighScores', 'setFirebaseFeedback']), {
    logIn: function logIn() {
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithRedirect(new __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].GithubAuthProvider());
    },
    logOut: function logOut() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signOut().then(function () {
        _this.setUser(null);
      });
    },
    firebase: function firebase() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["initializeApp"](firebaseConfig);

      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().onAuthStateChanged(function (user) {
        if (user) {
          __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + user.uid).set({
            name: user.displayName,
            email: user.email,
            photo_url: user.photoURL
          }).then(function () {
            _this2.setUser(user);
            _this2.setFirebaseFeedback();
          });
        } else {
          _this2.setFirebaseFeedback();
        }
      });
    },
    saveScore: function saveScore() {
      var _this3 = this;

      if (this.user) {
        var name = this.user.displayName || this.user.email.substring(0, this.user.email.indexOf('@'));
        var objToDb = {
          answerCount: this.answerCount,
          amount: this.amount,
          startTime: this.startTime,
          endTime: this.endTime,
          name: name
        };

        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/scores/' + this.user.uid).once('value').then(function (snapshot) {
          var previousScore = snapshot.val();
          if (!previousScore || previousScore && _this3.shouldSaveNewScore(objToDb, previousScore)) {
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('scores/' + _this3.user.uid).set(objToDb);
          }
        });
      }
    },
    shouldSaveNewScore: function shouldSaveNewScore(newScore, oldScore) {
      var higherScore = newScore.answerCount > oldScore.answerCount;
      var sameScore = newScore.answerCount === oldScore.answerCount;
      var betterTime = newScore.endTime - newScore.startTime < oldScore.endTime - oldScore.startTime;
      var isNotCheating = newScore.endTime - newScore.startTime > this.answerCount * 1000;
      return isNotCheating && (higherScore || sameScore && betterTime);
    },
    getHighScores: function getHighScores() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/scores').orderByChild('answerCount').limitToLast(10).once('value').then(function (snapshot) {
        if (snapshot.val()) {
          var highScores = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(snapshot.val()).map(function (k) {
            return snapshot.val()[k];
          }).sort(function (a, b) {
            if (a.answerCount > b.answerCount) {
              return -1;
            } else if (b.answerCount > a.answerCount) {
              return 1;
            } else {
              return 0;
            }
          });
          _this4.setHighScores(highScores);
        }
      });
    }
  })
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JsLogo__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UiOptions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UiOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UiOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResultPage__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResultPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ResultPage__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    JsLogo: __WEBPACK_IMPORTED_MODULE_2__JsLogo___default.a,
    UiOptions: __WEBPACK_IMPORTED_MODULE_3__UiOptions___default.a,
    ResultPage: __WEBPACK_IMPORTED_MODULE_4__ResultPage___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['gameFinished', 'answerCount', 'logos', 'currentLogo', 'amount'])),
  created: function created() {
    var _this = this;

    this.initializeLogos(function () {
      _this.restartGame();
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['initializeLogos', 'setCurrentLogo', 'setOptions', 'increaseAnswerCount', 'playSound', 'finishGame', 'restartGame']), {
    answer: function answer(answerId) {
      if (answerId === this.currentLogo.id) {
        this.increaseAnswerCount();
        if (this.answerCount === this.amount) {
          this.playSound('game-end');
          this.finishGame();
          this.$emit('save-score');
        } else {
          this.playSound('correct');
          this.setCurrentLogo(this.logos[this.answerCount]);
          this.setOptions();
        }
      } else {
        this.playSound('wrong');
        this.finishGame();
        this.$emit('save-score');
      }
    }
  })
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      prod: "production" === 'production'
    };
  },

  props: {
    size: {
      type: Number,
      default: 100
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    currentLogo: 'currentLogo',
    gameFinished: 'gameFinished'
  }), {
    logoUrl: function logoUrl() {
      if (!this.currentLogo.name) {
        return undefined;
      }

      return '../static/logos/' + (this.prod ? this.currentLogo.uuid : this.currentLogo.name.toLowerCase()) + '.png';
    },
    altContext: function altContext() {
      return this.gameFinished ? 'Learn about this JavaScript library' : 'Guess this logo';
    }
  }),
  mounted: function mounted() {
    if (this.logoUrl) {
      this.show = true;
    }
  },
  watch: {
    logoUrl: function logoUrl(val) {
      var _this = this;

      this.show = false;
      setTimeout(function () {
        _this.show = true;
      }, 1);
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dropdownOpen: false
    };
  },

  watch: {
    dropdownOpen: function dropdownOpen(value) {
      if (!value) {
        document.removeEventListener('click', this.dropdownAction);
      }
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['user', 'routePath', 'firebaseFeedback']),
  methods: {
    openDropdown: function openDropdown(e) {
      var _this = this;

      e.preventDefault();
      if (!this.dropdownOpen) {
        document.addEventListener('click', this.dropdownAction);
        window.setTimeout(function () {
          _this.dropdownOpen = true;
        });
      }
    },
    dropdownAction: function dropdownAction(e) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.target.className) === 'object' || e.target.className.indexOf('dropdown') < 0) {
        this.dropdownOpen = false;
      }
    },
    logIn: function logIn() {
      this.$emit('log-in');
    },
    logOut: function logOut() {
      this.$emit('log-out');
    },
    closeDropdown: function closeDropdown() {
      this.dropdownOpen = false;
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    answerCount: 'answerCount',
    amount: 'amount'
  }), {
    progress: function progress() {
      return this.answerCount / this.amount * 100 || 0;
    }
  })
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['highScores']))
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JsLogo__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JsLogo__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    JsLogo: __WEBPACK_IMPORTED_MODULE_2__JsLogo___default.a
  },
  data: function data() {
    return {
      insults: ['Why don\'t you go back to your desk and tail call yourself?', 'I never believed in chaos theory until I saw your variable naming convention!', 'Your commit is writing checks your merge can\'t cash.', 'Your code, just like C. Has no class!', 'Your coding methods are so backwards they\'ve added it to the school curriculum in Texas!', 'Your code runs so slow your data brings sleeping bags to camp-out in the cache lines.', 'More unit tests? No! What your code needs is petrol and a match.', 'Imagine an egg hitting a concrete pavement, that\'s how hard-wired, inflexible and brittle your code is.', 'Don\'t worry about it, I\'ll get someone technical to do this.', 'You\'re slower than a Java app.', 'You are one tab level off.', 'Your code looks as though you have been playing bingo with anti-patterns.', 'Your code is so wretched, that hard disks add it to their bad block lists.', 'Clean, clear, and under control; three things that will never be said about your code.', 'By popular demand, your code backup is in /dev/null/.', 'Your webpages only render in IE 5.5.', '*Knock, knock* "Who\'s there?" *long pause* Your init method.', 'There may be no I in TEAM, but I can\'t spell B GS, without U.', 'If Perl scripts could carry coffee around, I could replace you with a one-liner.']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    amount: 'amount',
    answerCount: 'answerCount',
    currentLogo: 'currentLogo'
  }), {
    insult: function insult() {
      var progress = this.answerCount / this.amount * 100 || 0;
      if (progress < 1) {
        return 'Do you even JavaScript, bro?';
      } else if (progress >= 100) {
        return 'You did it! Now you can go back to your desk and start working.';
      } else {
        return this.insults[Math.floor(Math.random() * this.insults.length)];
      }
    },
    twitterText: function twitterText() {
      return 'You know there are too many JS libraries when there is a game for it \uD83C\uDFAF \n I got ' + this.answerCount + '/' + this.amount + '. Try it out! https://javascript-game.firebaseapp.com';
    },
    isLongInsult: function isLongInsult() {
      return this.insult.length > 60;
    }
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['restartGame'])
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text', 'id'],
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.$el.addEventListener('mouseup', _this.debounce(_this.cleanUp, 2000));
    });
  },
  methods: {
    onDown: function onDown(e) {
      this.showRipple(e);
      document.activeElement.blur();
      e.preventDefault();
    },
    showRipple: function showRipple(e) {
      var pos = void 0,
          button = void 0,
          rippler = void 0,
          size = void 0,
          style = void 0,
          x = void 0,
          y = void 0;
      if (e.target.tagName === 'BUTTON') {
        button = e.target;
      } else {
        button = e.target.parentNode;
        if (button.tagName === 'DIV') {
          button = e.target.parentNode.parentNode;
        }
      }
      rippler = document.createElement('span');
      size = button.offsetWidth;
      pos = button.getBoundingClientRect();
      x = e.pageX - pos.left - size / 2;
      y = e.pageY - pos.top - size / 2;
      style = 'top:' + y + 'px; left: ' + x + 'px; height: ' + size + 'px; width: ' + size + 'px;';
      button.querySelector('.ripple--container').appendChild(rippler);
      return rippler.setAttribute('style', style);
    },
    cleanUp: function cleanUp(e) {
      var rippleContainer = void 0;
      if (e.target.tagName === 'SPAN') {
        rippleContainer = e.target.parentNode;
      } else if (e.target.tagName === 'BUTTON') {
        rippleContainer = e.target.firstChild;
      }
      while (rippleContainer.firstChild) {
        rippleContainer.removeChild(rippleContainer.firstChild);
      }
    },
    debounce: function debounce(func, delay) {
      var inDebounce = void 0;
      inDebounce = undefined;
      return function () {
        var args = void 0,
            context = void 0;
        context = this;
        args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function () {
          return func.apply(context, args);
        }, delay);
        return inDebounce;
      };
    },
    onClick: function onClick() {
      this.$emit('button-click', this.id);
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    sound: 'sound'
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['toggleSound'])
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RippleButton__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RippleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RippleButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RippleButton: __WEBPACK_IMPORTED_MODULE_2__RippleButton___default.a
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    options: 'options'
  })),
  methods: {
    answer: function answer(id) {
      this.$emit('answer', id);
    }
  }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(123)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  "data-v-64698a2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  "data-v-6f376786",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(142),
  /* scopeId */
  "data-v-321fe375",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(140),
  /* scopeId */
  "data-v-088b1666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  "data-v-dd4e00dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(141),
  /* scopeId */
  "data-v-31408df9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    class: {
      'long-insult': _vm.isLongInsult
    }
  }, [_vm._v(_vm._s(_vm.insult))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.answerCount) + " / " + _vm._s(_vm.amount))]), _vm._v(" "), _c('button', {
    staticClass: "ripple-button button",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n    Restart\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "custom-tweet-button"
  }, [_c('a', {
    attrs: {
      "href": ("https://twitter.com/intent/tweet?text=" + ((_vm.twitterText))),
      "target": "_blank",
      "alt": "Tweet your score"
    }
  }, [_c('i', {
    staticClass: "btn-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Tweet your score")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "ranking-link",
    attrs: {
      "to": "ranking"
    }
  }, [_c('h3', [_c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "24",
      "viewBox": "0 0 24 12",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
    }
  })]), _vm._v("\n      See High Scores\n    ")])]), _vm._v(" "), (_vm.answerCount !== _vm.amount) ? _c('div', {
    staticClass: "learning-suggestion"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentLogo.url,
      "target": "_blank"
    }
  }, [_c('js-logo', {
    attrs: {
      "size": 55
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n      I am \n      "), _c('a', {
    attrs: {
      "href": _vm.currentLogo.url,
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.currentLogo.name) + "!")])]), _vm._v(" \n      Click me to learn more.\n    ")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-github-button"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game",
      "target": "_blank",
      "alt": "Star samiheikki/javascript-guessing-game on GitHub"
    }
  }, [_c('i', {
    staticClass: "btn-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Star on GitHub")])])])
}]}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.show) ? _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.options), function(option) {
    return _c('ripple-button', {
      staticClass: "button",
      attrs: {
        "text": option.name,
        "id": option.id
      },
      on: {
        "button-click": _vm.answer
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "answer-count": _vm.answerCount,
      "amount": _vm.amount,
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      width: _vm.progress + '%'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h4', [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "24",
      "viewBox": "0 0 24 16",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]), _vm._v("\n        Play the game\n      ")])])], 1), _vm._v(" "), _c('h1', [_vm._v("High Scores (top 10)")]), _vm._v(" "), _c('div', {
    staticClass: "scores-container"
  }, [_vm._l((_vm.highScores), function(score, index) {
    return _c('div', {
      staticClass: "score-row"
    }, [_c('h2', {
      staticClass: "score-number"
    }, [_vm._v("#" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "score-row-details"
    }, [_c('h3', [_vm._v(_vm._s(score.name || 'Anonymous'))]), _vm._v(" "), _c('span', {
      staticClass: "extra-detail"
    }, [_vm._v(_vm._s(score.answerCount) + " / " + _vm._s(score.amount))])])])
  }), _vm._v(" "), (_vm.highScores.length === 0) ? _c('div', [_c('h3', [_vm._v("Loading...")])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('img', {
    staticClass: "logo",
    style: ({
      height: _vm.size + 'px',
      width: _vm.size + 'px'
    }),
    attrs: {
      "src": _vm.logoUrl,
      "alt": _vm.altContext
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ripple-button",
    attrs: {
      "ripple": ""
    },
    on: {
      "mousedown": _vm.onDown,
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "ripple--container"
  }), _vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._v("\n  By "), _c('a', {
    attrs: {
      "href": "https://suoheikki.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n    Sami Suo-Heikki\n    "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "12",
      "viewBox": "0 0 24 24",
      "width": "12",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  })])]), _vm._v("\n  and\n  "), _c('a', {
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game/graphs/contributors",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n    Contributors\n    "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "12",
      "viewBox": "0 0 24 24",
      "width": "12",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firebaseFeedback) ? _c('div', {
    staticClass: "login-root"
  }, [(!_vm.user) ? _c('button', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.logIn
    }
  }, [_vm._v("Sign in with GitHub")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.openDropdown
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoURL,
      "alt": _vm.user.displayName
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.dropdownOpen && _vm.user) ? _c('div', {
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header"
  }, [_vm._v("\n        Signed in as "), _c('strong', {
    staticClass: "dropdown-name"
  }, [_vm._v(_vm._s(_vm.user.displayName || _vm.user.email || 'Anonymous'))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), (_vm.routePath === '/') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/ranking"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDropdown($event)
      }
    }
  }, [_vm._v("High scores")]) : _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDropdown($event)
      }
    }
  }, [_vm._v("Play the game")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Sign out")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game"
    }
  }, [_vm._v("Source code")])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('progress-bar'), _vm._v(" "), _c('sound-toggle'), _vm._v(" "), _c('login-view', {
    on: {
      "log-in": _vm.logIn,
      "log-out": _vm.logOut
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "save-score": _vm.saveScore
    }
  }), _vm._v(" "), (_vm.routePath === '/') ? _c('credits', {
    staticClass: "credits"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sound) ? _c('svg', {
    on: {
      "click": _vm.toggleSound
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
    }
  })]) : _c('svg', {
    on: {
      "click": _vm.toggleSound
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.gameFinished) ? _c('js-logo') : _vm._e(), _vm._v(" "), (!_vm.gameFinished) ? _c('ui-options', {
    on: {
      "answer": _vm.answer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gameFinished) ? _c('result-page') : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
]),[58]);


// WEBPACK FOOTER //
// static/js/app.8b9f0d0f592f611067b4.js